module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_08_oranzova.d5f5177d.png";